import Alert from '@storeblocks/alert-rebrand';
import Box from '@storeblocks/box';
import { FormikErrors, useFormikContext } from 'formik';
import React from 'react';
import { getAppText } from 'Utils/text';
import { displayFormErrorDebugger } from './formErrorDebugger.helpers';

const isErrorsPopulatedObject = (
  errors: FormikErrors<unknown>,
): errors is FormikErrors<Record<string, unknown>> => {
  return errors && Object.keys(errors).length !== 0;
};

export const FormErrorDebugger = () => {
  const { errors } = useFormikContext<unknown>();
  const { displayDebugger } = displayFormErrorDebugger();

  if (!displayDebugger || !isErrorsPopulatedObject(errors)) {
    return null;
  }

  return (
    <Alert
      fluid
      variant="error"
      className="subsection-near-bottom"
      title={getAppText('formErrorDebugger.title')}
    >
      <Errors errors={errors} />
    </Alert>
  );
};

const Errors = ({ errors }: { errors: Record<string, unknown> }) => {
  return (
    <>
      {Object.keys(errors).map((key) => {
        const value = errors[key];
        return (
          <Box background="transparent" display="block" key={key} pl="16px">
            <strong>{key}</strong>
            {': '}
            <FormErrorValue value={value} />
            <br />
          </Box>
        );
      })}
    </>
  );
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const FormErrorValue = ({ value }: { value: unknown }) => {
  if (isRecord(value)) {
    return (
      <>
        {'{'}
        <br />
        <Errors errors={value} />
        {'}'}
      </>
    );
  }
  if (typeof value === 'string') {
    return <span>{value}</span>;
  }
  return <span>{JSON.stringify(value)}</span>;
};
